import React from 'react'

const Bullet = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/bullet',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <circle cx={10} cy={10} r={2} fill={primaryColor} fillRule='evenodd' />
  </svg>
)

export default Bullet
